export enum StatusCode {
    MovedPermanently301 = '301',
    Found302 = '302',
    TemporaryRedirect307 = '307',
    PermanentRedirect308 = '308',
}